/**
 * How often the miniatures view re-reads a miniature whose image is still being
 * flattened. The flatten runs on the server's heavy-job queue, usually within
 * seconds.
 */
export const FLATTEN_POLL_MS = 3000;

/**
 * Whether a miniature's latest image flatten is still queued or running. The API
 * sets `flatten_status` to pending | processing | failed while a flatten is
 * unfinished or failed, and leaves it out once the latest one completed.
 * @param {{ flatten_status?: string } | null | undefined} miniature
 * @returns {boolean}
 */
export function isFlattenPending(miniature) {
    const status = miniature?.flatten_status;
    return status === 'pending' || status === 'processing';
}

/**
 * Whether any miniature in a list is still being flattened.
 * @param {Array<{ flatten_status?: string }> | null | undefined} miniatures
 * @returns {boolean}
 */
export function anyFlattenPending(miniatures) {
    return (miniatures || []).some(isFlattenPending);
}
